module.exports = __webpack_public_path__ + "static/img/case_mobile.ba33784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Virus/Lentivirus/case_mobile.png
// module id = Y84U
// module chunks = 16